import React from "react";
import { AccessType } from "../../swagger-clients/s365-dashboard-v2-api-clients.service";


type ShareAccessTypeProps = {
    value: AccessType;
    style?: React.CSSProperties;
}

export const ShareAccessType: React.FC<ShareAccessTypeProps> = (props) => {

    const label = React.useMemo(() => { return getShareAccessTypeLabel(props.value) }, [props.value]);
    return <span style={props.style}>{label}</span>

}

const getShareAccessTypeLabel = (value: AccessType) => {
    switch (value) {
        case AccessType.ReadOnly:
            return "Read-only";
        case AccessType.Collaboration:
            return "Collaboration";
        default:
            return "";

    }
}